export default "/images/aregak_bank.png?8e8e3cf8f01aaf16cf8ad087fcca4458";